export default __webpack_public_path__ + "static/media/hardwareMode.71056e34.svg";